// Define qué roles pueden acceder a qué rutas protegidas
export const routeRoles = {
  "/app/dashboard": ["admin", "dashboard"]
};